import { AppUtils } from '../utils';
import { BasicApplicationUrlBuilder } from './BasicApplicationUrlBuilder';

/**
 * Performs typical redirects using the configurations from the provided options.
 */
export class BasicApplicationRouter<T extends BasicAppDefinition> {
	protected readonly errorUrl: string;
	protected readonly membershipUrl: string;
	protected readonly prevUrl: string;
	protected readonly nextUrl: string;
	protected readonly applicationUrlBuilder: BasicApplicationUrlBuilder<T>;

	constructor(options: BasicAppOptions<T>) {
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder<T>(options);

		this.nextUrl = options.app.nexturl;
		this.prevUrl = options.app.prevurl;
		this.membershipUrl = options.app.mglurl;
		this.errorUrl = options.app.errorurl;
	}

	/* istanbul ignore next: wrapper function */
	public routeToLocation(location: string, queryString?: string): void {
		let fullUrl = location;
		if (queryString !== undefined) {
			fullUrl = AppUtils.Url.mergeQueryParams(location, queryString);
		}
		T.Utils.Helper.routeToUrl(fullUrl);
	}

	/**
	 * Performs a login redirect that ends at the provided process url. If no process url is provided, the process ends at the current page.
	 */
	/* istanbul ignore next: wrapper function */
	public login(): void {
		T.Utils.Auth.authorize();
	}

	/* istanbul ignore next: wrapper function */
	public logout(redirectUrl?: string): void {
		T.Utils.Auth.logoutFinally(redirectUrl);
	}

	/* istanbul ignore next: wrapper function */
	public async register(): Promise<void> {
		const registerUrl = await this.applicationUrlBuilder.registerUrl();
		this.routeToLocation(registerUrl);
	}

	/* istanbul ignore next: wrapper function */
	public next(queryString?: string): void {
		let url = T.Utils.Helper.appendDeviceUrlParam(this.nextUrl);
		url = T.Utils.Helper.appendCampaignUrlParam(url);
		this.routeToLocation(url, queryString);
	}

	/* istanbul ignore next: wrapper function */
	public back(queryString?: string): void {
		let url = T.Utils.Helper.appendDeviceUrlParam(this.prevUrl);
		url = T.Utils.Helper.appendCampaignUrlParam(url);
		this.routeToLocation(url, queryString);
	}

	/* istanbul ignore next: wrapper function */
	public membership(): void {
		this.routeToLocation(this.membershipUrl);
	}

	/* istanbul ignore next: wrapper function */
	public error(): void {
		this.routeToLocation(this.errorUrl);
	}

}
